import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales'
export default formatTableJson([
  // {
  //   filed: 'type',
  //   label: '推送类型',
  //   width: '200px',
  //   showOverflowTooltip: true
  // },
  {
    filed: 'content',
    label: i18n.t('Message.pushContent'),
    width: '300px',
    showOverflowTooltip: true
  },
  {
    filed: 'pushUserName',
    label: i18n.t('Message.pushUser')
  },
  {
    filed: 'productTypeName',
    label: i18n.t('Message.productType')
  },
  {
    type: 'time',
    filed: 'pushDateTime',
    label: i18n.t('Message.pushTime'),
    width: '160px'
  }

  // {
  //   filed: 'clickActionName',
  //   label: '点击动作',
  //   width: '200px',
  //   showOverflowTooltip: true
  // }
])
